import { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface MarqueeProps {
    children: React.ReactNode;
    direction?: 'left' | 'right';
    speed?: number;
    className?: string;
}

export const Marquee = ({ children, direction = 'left', speed = 20, className = '' }: MarqueeProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            setContentWidth(contentRef.current.offsetWidth);
        }
    }, [children]);

    // If content is not loaded yet or width is 0, don't animate properly
    const duration = contentWidth > 0 ? contentWidth / speed : 10;

    return (
        <div className={`overflow-hidden flex ${className}`} ref={containerRef}>
            <motion.div
                className="flex shrink-0 gap-8 min-w-full"
                initial={{ x: direction === 'left' ? 0 : -contentWidth }}
                animate={{ x: direction === 'left' ? -contentWidth : 0 }}
                transition={{
                    repeat: Infinity,
                    ease: "linear",
                    duration: duration,
                }}
            >
                <div ref={contentRef} className="flex gap-8 shrink-0">
                    {children}
                </div>
                {/* Duplicate content for seamless loop */}
                <div className="flex gap-8 shrink-0">
                    {children}
                </div>
                <div className="flex gap-8 shrink-0">
                    {children}
                </div>
            </motion.div>
        </div>
    );
};
